import { GetterTree } from "vuex";
import * as types from "@/store/constants/types";

const Getters: GetterTree<any, any> = {
    [types.GETTER_IS_REDIRECT](state, getters, rootState) {
        return state.isRedirect;
    },
    [types.GETTER_HAS_REDIRECT](state, getters, rootState) {
        return state.hasRedirect;
    }
};

export default Getters;
